import React from 'react'
import styles from './styles'
import { css } from 'aphrodite'
import { state, signal } from 'cerebral/tags'
import { connect } from '@cerebral/react'
import { Action } from '@billes/components'
import { Send, Node as NodeIcon } from 'components/Icons'
import { field } from '@cerebral/forms'
import { t } from '@billes/translator-client'
import Close from './close'
import { Common } from 'styles'
import { Calendar } from './Calendar'
import { PillContainer } from 'components/Common/PillContainer'
import { Pill } from 'components/Common/PillContainer/Pill'

const Node = connect(
  {
    show: state`node.panel.show`,
    name: field(state`node.panel.name`),
    onChangeNodeName: signal`node.onChangeNodeName`,
    saveNode: signal`node.saveNode`,
    toggleGroup: signal`node.toggleGroup`,
    isMenuOpen: state`node.tree.open`,
    isMenuTransition: state`node.tree.transition`
  },
  ({
    show,
    name,
    onChangeNodeName,
    saveNode,
    toggleGroup,
    isMenuOpen,
    isMenuTransition
  }) => {
    if (!show) {
      return null
    }
    return (
      <div
        style={{
          width: Common.nodeMenuWidth,
          minWidth: Common.nodeMenuWidth,
          left: !isMenuOpen && !isMenuTransition ? Common.treeClosedWidth : 0
        }}
        className={css(styles.motionContainer)}
      >
        <div className={css(styles.container)}>
          <div className={css(styles.nodeIconContainer)}>
            <div style={{ flexGrow: 1 }}>
              <NodeIcon />
            </div>
            <Close />
          </div>
          <div className={css(styles.innerContainer)}>
            <span>{t('bms.name')}</span>
            <input
              value={name.value}
              placeholder={t('bms.name')}
              type={'text'}
              onChange={e => onChangeNodeName({ value: e.target.value })}
              className={css(styles.input)}
              onKeyDown={e => {
                if (e.keyCode === 13 && name.isValid) {
                  saveNode()
                }
              }}
            />
            {!name.isValid && name.failedRule ? (
              <span style={{ color: 'red' }}>
                {t(`bms.node.error.${name.failedRule.name}`)}
              </span>
            ) : null}
            <div style={{ marginTop: 10, zIndex: 100 }}>
              <span>{t('bms.groups')}</span>
              <PillContainer
                path={'node.panel.tags'}
                renderTag={({ key, path }) => {
                  return <Pill key={key} path={path} type={'node'} editMode />
                }}
              />
            </div>
            <div style={{ marginTop: 10 }}>
              <span>{t('bms.node.fromToDate')}</span>
              <Calendar />
            </div>
            <div style={{ marginTop: 50 }}>
              <Action
                icon={<Send />}
                label={t('common.save')}
                disabled={!name.isValid}
                action={e => saveNode()}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
)

export default Node



// WEBPACK FOOTER //
// ./src/components/Node/node.js